import { CardIcon, type ICardIconName } from '@components/Pages/AnalyticsPage/CardIcon';
import classes from './StatBlock.module.css';

interface IStatBlockProps {
  icon: ICardIconName;
  label: string;
  value: string | number;
}

/**
 * Tabular stat block: 32px icon-circle on the left, label-over-value on
 * the right. Used by the workers/hours chart's averages strip and the
 * location panel's active-locations / total-hours header. Mirrors
 * trusstor's V2 strip exactly.
 */
export function StatBlock({ icon, label, value }: IStatBlockProps) {
  return (
    <div className={classes.root}>
      <span className={classes.icon}>
        <CardIcon name={icon} size={18} />
      </span>
      <div className={classes.meta}>
        <span className={classes.label}>{label}</span>
        <span className={classes.value}>{value}</span>
      </div>
    </div>
  );
}
